"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const habitatMapLogo_svg_1 = __importDefault(require("../../../../assets/icons/habitatMapLogo.svg"));
const iconNavClose_svg_1 = __importDefault(require("../../../../assets/icons/iconNavClose.svg"));
const searchIcon_svg_1 = __importDefault(require("../../../../assets/icons/searchIcon.svg"));
const urls_1 = require("../../../../const/urls");
const NavItem_1 = __importDefault(require("./NavItem"));
const S = __importStar(require("./NavList.style"));
const navItemsList_1 = require("./navItemsList");
const NavList = ({ t, navMenuVisible, toggleMenuVisibility, onOpenCookieSettings, }) => (react_1.default.createElement(S.NavList, { "$isVisible": navMenuVisible },
    react_1.default.createElement(S.NavHeader, null,
        react_1.default.createElement("a", { href: urls_1.urls.aircasting, "aria-label": t("navbar.sections.habitatMapPage"), style: { display: "flex", alignItems: "center" } },
            react_1.default.createElement("img", { src: habitatMapLogo_svg_1.default, alt: t("navbar.altHabitatMapLogo") })),
        react_1.default.createElement(S.Button, { onClick: toggleMenuVisibility },
            react_1.default.createElement("img", { src: iconNavClose_svg_1.default, "aria-label": t("navbar.altClose"), alt: t("navbar.altClose") }))),
    navItemsList_1.navItems.map((item) => {
        var _a;
        return (react_1.default.createElement(NavItem_1.default, { key: item.href, href: item.href, isNavTitle: item.isNavTitle, isActive: window.location.pathname === item.href, subNav: (_a = item.subNav) === null || _a === void 0 ? void 0 : _a.map((subItem) => (Object.assign(Object.assign({}, subItem), { label: t(subItem.label), onClick: subItem.onClick === "openCookieSettings"
                    ? onOpenCookieSettings
                    : undefined }))) }, t(item.label)));
    }),
    react_1.default.createElement(S.BottomNavContainer, null,
        react_1.default.createElement("a", { href: urls_1.urls.search },
            react_1.default.createElement("img", { src: searchIcon_svg_1.default, alt: t("navbar.altSearch"), "aria-label": t("navbar.altSearch"), style: { width: "30px" } })),
        react_1.default.createElement(S.Link, { href: urls_1.urls.donate, style: { fontSize: "1.2rem" } }, t("navbar.sections.donate")),
        react_1.default.createElement(S.BuyCTAWhite, { href: urls_1.urls.airbeamBuyNow }, t("navbar.sections.getAirbeam")))));
exports.default = NavList;
